module.exports = __webpack_public_path__ + "img/Etape 3 - 1.b88452f5.png";